<template>
    <div class="coshh-form row">

<!--        <div class="loaders&#45;&#45;container" v-if="loading || saving">-->
<!--            <div class="loaders&#45;&#45;standard"></div>-->
<!--        </div>-->

        <div class="col-12 col-sm-6">
            <div class="form-group">
                <h5 class="form-title">Material</h5>
                <input type="text" class="form-control" id="material" placeholder="Enter Material" v-model="coshhData.material">
            </div>
        </div>

        <div class="col-12 col-sm-6">
            <div class="form-group coshh-form--data">
                <h5 class="form-title">Data</h5>

                <div class="coshh-form--data-fields">
                    <a class="coshh-form--data-link" :href="coshhData.full_path">
                        <input class="coshh-form--data-name form-control" placeholder="Document Name" type="text" :value="coshhData.data_filename" readonly>
                        <div class="coshh-form--data-icon">
                            <svg-image
                                :src="`/svg/${resource_group}/edit.svg`"
                                width="20px"
                                height="25px"
                            ></svg-image>
                        </div>
                    </a>

                    <div class="coshh-form--data-button-container">
                        <upload-image-button
                            @file="coshhData.data = $event"
                            button_class="btn btn-success coshh-form--data-button"
                            :label="coshhData.data ? 'Change' : 'Upload'"
                            :disable_data_encode="true"
                        ></upload-image-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <h5 class="form-title">Categorize The Hazard</h5>

                <div class="coshh-form--hazard-categories">
                    <div class="hazard-category" v-for="hazard in hazardCategories">
                        <label class="checkbox">
                            <input type="checkbox" v-model="coshhData.selected_categories" :value="hazard.id">
                            <img :src="hazard.full_path" class="checkbox--image hazard-category--image">
                            <div class="hazard-category--title">{{hazard.name}}</div>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <h5 class="form-title">What is the route of exposure?</h5>

                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4" v-for="route in exposureRoutes">
                        <label class="checkbox">
                            <div class="form-checkbox">
                                <span class="form-checkbox--label">{{route.name}}</span>

                                <input type="checkbox" v-model="coshhData.selected_routes" :value="route.id">
                                <div class="checkbox--check"></div>
                            </div>

                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <h5 class="form-title">How long is the likely exposure?</h5>

                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4" v-for="time in exposureTimes">
                        <label class="checkbox">
                            <div class="form-checkbox">
                                <span class="form-checkbox--label">{{time.name}}</span>
                                <input type="checkbox" :checked="time.id == coshhData.exposure_time_id" @input="coshhData.exposure_time_id = time.id">
                                <div class="checkbox--check"></div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <h5 class="form-title">What are the control measures?</h5>

                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4" v-for="control in hazardControls">
                        <label class="checkbox">
                            <div class="form-checkbox">
                                <span class="form-checkbox--label">{{control.name}}</span>

                                <input type="checkbox" v-model="coshhData.selected_controls" :value="control.id">
                                <div class="checkbox--check"></div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <div class="form-group">
                <h5 class="form-title">What are the control measures?</h5>

                <div class="coshh-form--ppes">
                    <div class="ppe" v-for="ppe in ppes">
                        <label class="checkbox">
                            <input type="checkbox" v-model="coshhData.selected_ppes" :value="ppe.id">
                            <img :src="ppe.full_path" class="checkbox--image ppe--image">
                            <div class="ppe--title">{{ppe.name}}</div>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12" v-if="coshh.id != undefined">
            <div class="coshh-form--expiry">
                <label class="checkbox">
                    <div class="form-checkbox">
                        <span class="form-checkbox--label">I have reviewed the material and confirm to update expiry</span>

                        <input type="checkbox" v-model="coshhData.update_expiry">
                        <div class="checkbox--check"></div>
                    </div>
                </label>
            </div>
        </div>

        <div class="col-12 text-right">
            <button @click="save()" class="btn btn-primary">Save</button>
        </div>
    </div>
</template>

<script>
    import UploadImageButton from "../../general_components/UploadImageButton";

    export default {
        name: "CoshhCreateEditPage",

        components: {UploadImageButton},

        props: {
            method: {
                type: String,
                default: 'post'
            },
            submitUrl: {
                type: String,
                required: true
            },
            coshh: {
                type: Object,
                default: () => { return {} }
            },

            exposureRouteUrl: {
                type: String,
                required: true
            },
            exposureTimeUrl: {
                type: String,
                required: true
            },
            hazardCategoryUrl: {
                type: String,
                required: true
            },
            hazardControlUrl: {
                type: String,
                required: true
            },
            ppeUrl: {
                type: String,
                required: true
            },
            backUrl: {
                type: String,
                required: true
            }
        },

        data(){
            return {
                coshhData: {
                    material: '',
                    data: '',
                    exposure_time_id: '',
                    selected_categories: [],
                    selected_routes: [],
                    selected_controls: [],
                    selected_ppes: [],
                    update_expiry: false
                },

                exposureRoutes: {},
                exposureTimes: {},
                hazardCategories: {},
                hazardControls: {},
                ppes: {},

                loading: false,
                saving: false,

                errors: []
            }
        },

        beforeMount() {
            window.addEventListener('LAYOUT:primary_button', this.save);
            window.addEventListener('LAYOUT:cancel_button', this.cancel);

            this.loading = true;

            this.coshhData = {...this.coshhData, ...this.coshh};
            this.coshhData.data = '';

            if(Object.keys(this.coshh).length > 0){
                this.coshhData.selected_categories = [...this.coshhData.categories].map((item) => {
                    return item.id;
                });

                this.coshhData.selected_routes = [...this.coshhData.routes].map((item) => {
                    return item.id;
                });

                this.coshhData.selected_controls = [...this.coshhData.controls].map((item) => {
                    return item.id;
                });

                this.coshhData.selected_ppes = [...this.coshhData.ppes].map((item) => {
                    return item.id;
                });
            }

            axios.all([
                this.getExposureRoutes(),
                this.getExposureTimes(),
                this.getHazardCategories(),
                this.getHazardControls(),
                this.getPpes()
            ]).then(() => {
                this.loading = false;
            })
        },

        methods: {
            save: function(){
                this.errors = [];

                if (this.saving){
					return false;
                }

				this.saving = true;

                //as uploading an image formData should be used
                let formData = new FormData();

                formData.append('_method', this.method);

                Object.keys(this.coshhData).forEach((key) => {
                    if((typeof this.coshhData[key] === 'object') && this.coshhData[key] !== null && !(this.coshhData[key].type)){
                        Object.keys(this.coshhData[key]).forEach((innerKey) => {
                            formData.append(`${key}[${innerKey}]`, this.coshhData[key][innerKey]);
                        });
                        return;
                    }
                    formData.append(key, this.coshhData[key]);
                })

                axios.post(this.submitUrl, formData, {
                    headers: {
                        'Content-Type' : 'multipart/form-data',
                        'Accept' : 'application/json'
                    }
                }).then((response) => {
                    this.saving = false;
                    window.location.href = response.data.url;
                }).catch((error) => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }

                    this.saving = false;
                });
            },

            cancel: function(){
                window.location.href = this.backUrl;
            },

            getExposureRoutes: function(){
                return this.makeRequest(this.exposureRouteUrl)
                    .then((response) => {
                        this.exposureRoutes = response.data;
                    })
            },
            getExposureTimes: function(){
                return this.makeRequest(this.exposureTimeUrl)
                    .then((response) => {
                        this.exposureTimes = response.data;
                    })
            },
            getHazardCategories: function(){
                return this.makeRequest(this.hazardCategoryUrl)
                    .then((response) => {
                        this.hazardCategories = response.data;
                    })
            },
            getHazardControls: function(){
                return this.makeRequest(this.hazardControlUrl)
                    .then((response) => {
                        this.hazardControls = response.data;
                    })
            },
            getPpes: function(){
                return this.makeRequest(this.ppeUrl)
                    .then((response) => {
                        this.ppes = response.data;
                    })
            },

            makeRequest: function(url){
                return axios.get(url);
            }
        }
    }
</script>
